import React, { useEffect, useRef, useState, useContext } from "react";
import "./EmployeeMaster.css";
import { useLocation, useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  EmployeeLeaveTypeData,
  GetDropDownList,
  getEmployeeByIdUrl,
  InsertUpdateEmployeeMasterData,
  EmployeeAvailableLeaveBalance,
  DeleteInsertedLeave,
  GetReportingManagers,
  GetReportingManagerEmployee,
} from "../../../Helpers/API/APIEndPoints";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import InputForm from "../../../Components/InputForm/InputForm";
import { gd } from "date-fns/locale";
import notify from "../../../Helpers/ToastNotification";
import Heading from "../../../Components/Heading/Heading";
import { getContext } from "../../../Helpers/Context/Context";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { data } from "autoprefixer";
import { leaveTypeOptions } from "../../../Common/CommonJson";
import { Box, TextField, Typography } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import Modal from "@mui/material/Modal";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { Tooltip } from "antd";

const EmployeeMasterEdit = () => {
  let navigate = useNavigate();
  const { state } = useLocation();
  const [open, setOpen] = useState(false);
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeEid, setEmployeeEid] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [employeeShortName, setEmployeeShortName] = useState("");
  //Moksha 14-11

  const [employeeBirthDate, setEmployeeBirthDate] = useState<Date | null>(null);
  const [employeejoiningDate, setEmployeeJoiningDate] = useState<Date | null>(
    null
  );
  const [employeePanNo, setEmployeePanNo] = useState("");
  const [employeeAdharNo, setEmployeeAdharNo] = useState("");
  const [employeeBankAccNumber, setEmployeeBankAccNumber] = useState("");
  const [employeeDesignation, setEmployeeDesignation] = useState("");
  //Pinky Added for contactNumber and emergency number

  const [contactNumber, setContactNumber] = useState(null);
  const [emergencyContact, setEmergencyContact] = useState(null);

  const [formErrors, setFormErrors] = useState({});

  //Moksha 14-11
  const [CostCenter, setCostCenter] = useState<any>({});
  const [WorkPolicy, setWorkPolicy] = useState<any>({});
  const [TimesheetPolicy, setTimesheetPolicy] = useState<any>({});
  const timesheetPolicyId = useRef<any>(0);
  const [Efficiency, setEfficiency] = useState<any>({});
  const EfficiencyId = useRef<any>(0);
  const [employeeCostCenterOption, setEmployeeCostcenterOption] = useState<any>(
    []
  );
  const [employeeWorkPolicyOption, setEmployeeWorkPolicyOption] = useState<any>(
    []
  );
  const [employeeTimesheetPolicyOption, setEmployeeTimesheetPolicyOption] =
    useState<any>([]);
  const [employeeEfficiencyOption, setEmployeeEfficiencyOPtion] = useState<any>(
    []
  );
  const [employeeLoginId, setEmployeeLoginId] = useState("");
  // const [employeePassword, setEmployeePassword] = useState("");
  const [employeeRole, setEmployeeRole] = useState<any>(null);
  const employeeRoleIds = useRef<any>();
  const [leaveBalance, setLeaveBalance] = useState<any>("");
  const [employeeRoleOption, setEmployeeRoleOption] = useState<any>([]);
  const [reportingManager, setReportingManager] = useState(null);
  const [reportingManagerOption, setReportingManagerOption] = useState([]);
  const reportingManagerId = useRef<any>();
  //const [employeeEfficiency, setemployeeEfficiency] = useState("");
  const [location, setLocation] = useState("");
  const [isActive, setIsActive] = useState(true);

  const { EmployeeId } = getContext();
  //Sai Changes
  const [employeeLeaveTypeOptions, setLeaveTypeOptions] = useState<any>([]);

  const [employeeLeaveTypeSelectedData, setEmployeeLeavesData] = useState<any>(
    []
  );

  const [gridData, setGridData] = useState([]);
  const [showGrid, setShowGrid] = useState(false);
  const [empData, setEmpData] = useState([]);
  const [employeeLeaveId, setEmployeeLeaveId] = useState(0);
  const [empDataLeaveId, setEmpDataLeaveId] = useState(0);

  const { showLoader, hideLoader } = useContext(LoaderContext); //added by mahesh
  const [disabled, setDisabled] = useState(false);
  const [employeeleavingDate, setEmployeeLeavingDate] = useState<Date | null>(
    null
  );

  useEffect(() => {
    setGridData(empData);
  }, [empData]);

  const getEmployeeLeave = async (id) => {
    id = id || 0;

    if (id === undefined) {
      setLeaveBalance(0);
      return;
    }

    if (state !== null) {
      const { data } = await APICall(EmployeeAvailableLeaveBalance, "POST", {
        EmployeeId: state,
        LeaveTypeId: id,
      });

      if (data >= 0) {
        setLeaveBalance(data);
      }
    }
  };

  const getEmployeeLeaveData = async () => {
    let obj = {
      Eid: state !== null ? state : 0,
    };
    const { data } = await APICall(EmployeeLeaveTypeData, "POST", obj);

    if (data !== null) {
      setEmpData(data);
      setGridData(data);
    }
  };

  const handleOpen = (id, leaveid) => {
    setEmployeeLeaveId(id);
    setEmpDataLeaveId(leaveid);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const getEmpById = async () => {
    if (state !== null) {
      let post = {
        id: state,
      };

      const { data } = await APICall(getEmployeeByIdUrl, "POST", post);

      if (data !== null || typeof data !== "string") {
        setEmployeeId(data[0].id);
        setEmployeeEid(data[0].eid);
        setEmployeeName(data[0].name);
        setEmployeeShortName(data[0].shortName);
        //Moksha
        setEmployeeBirthDate(data[0].birthDate);
        setEmployeeJoiningDate(data[0].joiningDate);
        setEmployeeAdharNo(data[0].adharNo ? data[0].adharNo : "");
        setEmployeePanNo(data[0].panNo);
        setEmployeeBankAccNumber(data[0].bankAccountNumber);
        setEmployeeDesignation(data[0].designation);
        setEmployeeLeavingDate(data[0]?.leavingDate); // added by mahesh
        //Mok sha

        setContactNumber(data[0].contactNumber);
        setEmergencyContact(data[0].emergencyContact);

        setCostCenter({
          value: data[0].costCenterId,
          label: data[0].costCenter,
        });
        setWorkPolicy({
          value: data[0].workPolicyId,
          label: data[0].workPolicy,
        });
        timesheetPolicyId.current = data[0].timeSheetPolicy;
        EfficiencyId.current = data[0].efficiency;
        setIsActive(data[0].isActive);
        setEmployeeLoginId(data[0].loginId);
        // setEmployeePassword(data[0].password);
        setLeaveBalance(data[0].leaveBalance);
        employeeRoleIds.current = data[0].employeeRoleIds;
        reportingManagerId.current = data[0].reportingManagerId;
        setLocation(data[0].location);
        //Sai Changes
        setLeaveTypeOptions({
          value: data[0].id,
          label: data[0].LeaveType,
        });
      }
    }
  };

  const onLoadApiCall = async () => {
    await getEmpById();
    await getCostCenterData();
    await getWorkPolicyData();
    await getTimeSheetData();
    await getEfficiencyData();
    await getEmployeeRoles();
    await getReportingMangerData();
    //Sai Changes
    await getLeaveTypeData();
    await getEmployeeLeaveData();
  };

  useEffect(() => {
    //  debugger;
    onLoadApiCall();
  }, []);

  const CommonDropdownFunction = async (searchFor, searchValue) => {
    let postObject = {
      searchFor: searchFor,
      searchValue: searchValue,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);

    return data;
  };

  //CostCenter Dropdown from databse
  const getCostCenterData = async () => {
    let costcenterId = 1; //hardcoded
    var data = await CommonDropdownFunction("costcenter", costcenterId);

    if (data != undefined || data != null) {
      let costCenterArray = [];
      await data.map((costCenter) => {
        let tempObj = {
          value: costCenter.id,
          label: costCenter.costCenter1,
        };
        costCenterArray.push(tempObj);
      });

      setEmployeeCostcenterOption(costCenterArray);
    }
  };

  //workPolicy Dropdown
  const getWorkPolicyData = async () => {
    let workpolicyId = 1; //hardcoded

    //workPolicy Dropdown
    var data = await CommonDropdownFunction("policyname", workpolicyId);

    if (data != undefined || data != null) {
      let workPolicyArray = [];
      await data.map((workPolicy) => {
        let tempObj = {
          value: workPolicy.id,
          label: workPolicy.policyName,
        };
        workPolicyArray.push(tempObj);
      });

      setEmployeeWorkPolicyOption(workPolicyArray);
    }
  };

  //Leave Type Drope Down By Sai
  const getLeaveTypeData = async () => {
    let Id = 1; //hardcoded
    var data = await CommonDropdownFunction("EmployeeLeaveType", Id);

    if (data != undefined || data != null) {
      let leaveTypeArray = [];
      await data.map((leaveType) => {
        let tempObj = {
          value: leaveType.id,
          label: leaveType.leaveName,
        };
        leaveTypeArray.push(tempObj);
      });

      leaveTypeArray = leaveTypeArray.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
      setLeaveTypeOptions(leaveTypeArray);
      setEmployeeLeavesData(leaveTypeArray[0]);
    }
  };

  //TimesheetPolicy Dropdown
  const getTimeSheetData = async () => {
    let serchValueId = 1; //hardcoded
    var data = await CommonDropdownFunction("timesheet", serchValueId);

    if (data != undefined || data != null) {
      if (data.length > 0) {
        setEmployeeTimesheetPolicyOption(data);
        if (timesheetPolicyId.current !== 0) {
          let bindData = data.find(
            (ele) => ele.value === timesheetPolicyId.current
          );
          setTimesheetPolicy(bindData);
        }
      }
    }
  };

  //Efficency Dropdown
  const getEfficiencyData = async () => {
    let serachValueId = 1; //hardcoded
    var data = await CommonDropdownFunction("efficiency", serachValueId);

    if (data != undefined || data != null) {
      if (data.length > 0) {
        setEmployeeEfficiencyOPtion(data);
        if (EfficiencyId.current !== 0) {
          let bindData = data.find((ele) => ele.value === EfficiencyId.current);
          setEfficiency(bindData);
        }
      }
    }
  };

  //roles Dropdown
  const getEmployeeRoles = async () => {
    let serachValueId = 1; //hardcoded
    var data = await CommonDropdownFunction("employeeRoles", serachValueId);

    if (data != undefined || data != null) {
      if (data.length > 0) {
        setEmployeeRoleOption(data);

        if (
          employeeRoleIds.current !== undefined &&
          employeeRoleIds.current.length > 0
        ) {
          let employeeRolesArr = [];
          employeeRoleIds.current.forEach((element) => {
            let bindData = data.find((ele) => ele.value === element);
            employeeRolesArr.push(bindData);
          });
          setEmployeeRole(employeeRolesArr);
        }
      }
    }
  };

  //Reporting Manager Dropdown
  const getReportingMangerData = async () => {
    const requestParams = {
      Id: 1,
    };
    const { data } = await APICall(
      GetReportingManagerEmployee,
      "POST",
      requestParams
    );
    // console.log('Reporting Manger data',data);

    if (data != undefined || data != null) {
      if (data.length > 0) {
        let employeeArr = [];
        await data.map((employee) => {
          let tempObj = {
            value: employee.id,
            label: employee.name,
          };
          employeeArr.push(tempObj);
        });
        setReportingManagerOption(employeeArr);
        if (reportingManagerId.current !== 0) {
          let bindData = employeeArr.find(
            (ele) => ele.value === reportingManagerId.current
          );
          setReportingManager(bindData);
        }
      }
    }
  };

  const getDataOnSubmit = async (requestObject: any) => {
    if (requestObject !== null) {
      const res = await APICall(
        InsertUpdateEmployeeMasterData,
        "POST",
        requestObject
      );
      if (res.status === 1) {
        notify(res.status, res.message);
      } else {
        navigate(-1);
      }
    }
  };

  const checkValidation = (requestObject) => {
    //Moksha
    setFormErrors({});
    //Moksha
    const checkArr = [
      "eid",
      "name",
      "shortName",
      "loginId",
      // "password",
      "costCenterId",
      "efficiency",
      "timeSheetPolicy",
      "workPolicyId",
      "leaveBalance",
      "employeeRole",
      "reportingManagerId",
      // "BirthDate", //Moksha
      //   "JoiningDate",
      //   "PanNo",
      //   "AdharNo",
      //   "BankAccountNumber",
      //   "Designation", //Moksha
    ];

    let validator = false;

    for (let i = 0; i < checkArr.length; i++) {
      if (
        requestObject[checkArr[i]] === "" ||
        requestObject[checkArr[i]] === undefined ||
        requestObject[checkArr[i]] === null ||
        requestObject[checkArr[i]] < 0
      ) {
        validator = true;
        break;
      } else if (isNaN(requestObject["AdharNo"])) {
        setFormErrors((preState) => ({
          ...preState,
          ["aadhar_isNotinFormat"]: "Aadhar number is not in correct format",
        }));
        validator = true;
        break;
      } else if (requestObject["AdharNo"].length > 0) {
        if (requestObject["AdharNo"].length != 12) {
          setFormErrors((preState) => ({
            ...preState,
            ["aadhar_isNotinFormat"]: "Aadhar number must be 12 digits",
          }));
          validator = true;
          break;
        }
      } else if (requestObject["BirthDate"] == null) {
        setFormErrors((preState) => ({
          ...preState,
          ["birthError"]: "Please select the birth date",
        }));
        validator = true;
        break;
      } else if (requestObject["JoiningDate"] == null) {
        setFormErrors((preState) => ({
          ...preState,
          ["joinError"]: "Please select the joining date",
        }));
        validator = true;
        break;
      } else if (
        requestObject["Designation"] == null ||
        requestObject["Designation"] == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["designationError"]: "Please enter the designation",
        }));
        validator = true;
        break;
      } else if (
        requestObject["Location"] == null ||
        requestObject["Location"] == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["locationError"]: "Please enter the location",
        }));
        validator = true;
        break;
      } else if (
        requestObject["emergencyContact"] == null ||
        requestObject["emergencyContact"] == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["emerygency_isNotinFormat"]: "Please enter the emergencey Number",
        }));
        validator = true;
        break;
      } else if (
        requestObject["contactNumber"] == null ||
        requestObject["contactNumber"] == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["Number_isNotinFormat"]: "Please enter the contanct Number",
        }));
        validator = true;
        break;
      } else if (state && !isActive && requestObject["LeavingDate"] == null) {
        setFormErrors((preState) => ({
          ...preState,
          ["leaveError"]: "Please select the leaving date",
        }));
        validator = true;
        break;
      }
    }

    return validator; //contactNumber
  };

  const EmpDetailsArrayDestructure = (arr) => {
    let s = [];
    arr.map((i) => {
      s.push({
        Leave: Number(i.leaveId),
        Balance: Number(i.balance),
      });
    });

    return s;
  };

  const onClickFunction = async (action) => {
    if (action === "submit") {
      showLoader();
      let requestObject = {
        id: employeeId,
        eid: employeeEid,
        name: employeeName,
        shortName: employeeShortName,
        costCenterId: CostCenter ? CostCenter.value : null,
        workPolicyId: WorkPolicy ? WorkPolicy.value : null,
        timeSheetPolicy: TimesheetPolicy ? TimesheetPolicy.value : null,
        efficiency: Efficiency ? Efficiency.value : null,
        isActive: isActive,
        loginId: employeeLoginId,
        // password: employeePassword,
        leaveBalance: parseFloat(parseFloat(leaveBalance).toFixed(1)),
        employeeRole: employeeRole,
        reportingManagerId: reportingManager ? reportingManager.value : null,
        createdBy: Number(EmployeeId),
        modifiedBy: Number(EmployeeId),
        Location: location,
        LeaveBalanceArray: EmpDetailsArrayDestructure(empData),
        //Moksha 14-11
        BirthDate:
          employeeBirthDate !== null
            ? moment(employeeBirthDate).format(moment.HTML5_FMT.DATE)
            : null,
        JoiningDate:
          employeejoiningDate !== null
            ? moment(employeejoiningDate).format(moment.HTML5_FMT.DATE)
            : null,
        PanNo: employeePanNo,
        AdharNo: employeeAdharNo,
        BankAccountNumber: employeeBankAccNumber,
        Designation: employeeDesignation,
        contactNumber: contactNumber,
        emergencyContact: emergencyContact,
        LeavingDate:
          employeeleavingDate !== null
            ? moment(employeeleavingDate).format(moment.HTML5_FMT.DATE)
            : null,
        //Moksha 14-11
        // LeaveTypes: EmpDetailsArrayDestructure(empData);
        //sai Changes
        // LeaveTypeId:
        //   employeeLeaveTypeSelectedData.value !== null
        //     ? employeeLeaveTypeSelectedData.value
        //     : 1,
      };

      //submitApiCall
      const validate = checkValidation(requestObject);

      let emailIsValid;
      let loginIdIsValid;
      //check if email is valid
      if (
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
          requestObject.loginId
        )
      ) {
        emailIsValid = true;
      } else {
        emailIsValid = false;
      }
      //added by mahesh for   Login id
      if (
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
          requestObject.shortName
        )
      ) {
        loginIdIsValid = true;
      } else {
        loginIdIsValid = false;
      }
      //end

      if (validate) {
        notify(1, "Please fill required fields!");
      } else if (emailIsValid === false) {
        notify(1, "Email Id not valid!");
      } else if (loginIdIsValid === false) {
        notify(1, "Login Id not valid!");
      } else if (gridData.length === 0) {
        notify(1, "Please Click Add Leave Type and Check");
      } else {
        // setDisabled(true);
        await getDataOnSubmit(requestObject);
        await getEmployeeLeaveData();
      }
      hideLoader();
    }
    if (action === "reset") {
      setEmployeeEid("");
      setEmployeeName("");
      setEmployeeShortName("");
      setCostCenter(null);
      setWorkPolicy(null);
      setTimesheetPolicy(null);
      setEfficiency(null);
      setEmployeeLoginId("");
      // setEmployeePassword("");
      setLeaveBalance("");
      setEmployeeRole(null);
      setReportingManager(null);
      //Sai Changes
      setLocation("");
      //setLeaveTypeOptions(null);
      // setLeaveTypeOptions(null);
      setEmployeeLeavesData({});
      //Moksha 14-11
      setEmployeeBirthDate(null);
      setEmployeeJoiningDate(null);
      setEmployeePanNo("");
      setEmployeeAdharNo("");
      setEmployeeBankAccNumber("");
      setEmployeeDesignation("");
      setContactNumber(null);
      setEmergencyContact(null);
      setFormErrors({});

      //Moksha 14-11
    }

    if (action === "add") {
      const data = {
        name: employeeName,
        leave:
          employeeLeaveTypeSelectedData.label !== undefined
            ? employeeLeaveTypeSelectedData.label
            : "",
        balance: leaveBalance === "" ? 0 : leaveBalance,
        leaveId:
          employeeLeaveTypeSelectedData.value !== undefined
            ? employeeLeaveTypeSelectedData.value
            : "",
      };

      let check = containsObject(data, empData);
      if (!check) {
        setEmpData([...empData, data]);
      } else {
        const newState = empData.map((obj) => {
          if (obj.leaveId === data.leaveId) {
            return { ...obj, balance: data.balance };
          }
          return obj;
        });
        setEmpData(newState);
      }
    }
  };

  function containsObject(obj, list) {
    var i = false;
    list.forEach((element) => {
      if (element.leaveId === obj.leaveId) {
        i = true;
      }
    });
    return i;
  }

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "aadharNumber") {
      setEmployeeAdharNo(event.target.value);
      //Moksha
      setFormErrors((preState) => ({
        ...preState,
        ["aadhar_isNotinFormat"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["aadhar_isNotinFormat"]: "",
        }));

        //Moksha
      } else if (isNaN(event.target.value)) {
        setFormErrors((preState) => ({
          ...preState,
          ["aadhar_isNotinFormat"]: "Aadhar number can't have charecters",
        }));
      } else if (event.target.value.length !== 12) {
        setFormErrors((preState) => ({
          ...preState,
          ["aadhar_isNotinFormat"]: "Aadhar number must be 12 digits",
        }));
      }
    }
  };

  //Pinky validation for emergency contact number
  const handleEmergencyContactEvent = async (event: any, apiFieldName: any) => {
    debugger;
    if (apiFieldName === "eContact") {
      setEmergencyContact(event.target.value);

      setFormErrors((preState) => ({
        ...preState,
        ["emerygency_isNotinFormat"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["emerygency_isNotinFormat"]: "",
        }));

        //Moksha
      } else if (isNaN(event.target.value)) {
        setFormErrors((preState) => ({
          ...preState,
          ["emerygency_isNotinFormat"]:
            "Emergency Contact  number can't have charecters",
        }));
      } else if (event.target.value.length !== 10) {
        setFormErrors((preState) => ({
          ...preState,
          ["emerygency_isNotinFormat"]:
            "Emergency Contact number must be 10 digits",
        }));
      }
    }
  };
  //Pinky

  const handleContactEvent = async (event: any, apiFieldName: any) => {
    // debugger;
    if (apiFieldName === "Contact") {
      setContactNumber(event.target.value);

      setFormErrors((preState) => ({
        ...preState,
        ["Number_isNotinFormat"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["Number_isNotinFormat"]: "",
        }));
      } else if (isNaN(event.target.value)) {
        setFormErrors((preState) => ({
          ...preState,
          ["Number_isNotinFormat"]: "Contact  number can't have charecters",
        }));
      } else if (event.target.value.length !== 10) {
        setFormErrors((preState) => ({
          ...preState,
          ["Number_isNotinFormat"]: "Contact number must be 10 digits",
        }));
      }
    }
  };
  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "birthDate") {
      setEmployeeBirthDate(event);
      setFormErrors((preState) => ({ ...preState, birthError: "" }));
    }
    if (apiFieldName === "joiningDate") {
      setEmployeeJoiningDate(event);
      setFormErrors((preState) => ({ ...preState, joinError: "" }));
    }
    if (apiFieldName === "CostCenter") {
      setCostCenter(event);
    }
    if (apiFieldName === "workPolicy") {
      setWorkPolicy(event);
    }
    if (apiFieldName === "TimesheetPolicy") {
      setTimesheetPolicy(event);
    }
    if (apiFieldName === "Efficiency") {
      setEfficiency(event);
    }
    if (apiFieldName === "Roles") {
      setEmployeeRole(event);
    }
    if (apiFieldName === "reportingManager") {
      setReportingManager(event);
    }

    if (apiFieldName == "location") {
      setLocation(event);
    }
    //Sai Changes
    if (apiFieldName == "EmployeeLeaveType") {
      setEmployeeLeavesData(event);
      await getEmployeeLeave(event.value);
    }
    if (apiFieldName === "leavingDate") {
      setEmployeeLeavingDate(event);
      setFormErrors((preState) => ({ ...preState, leaveError: "" }));
    }
  };

  const removeAppliedLeave = async () => {
    if (employeeLeaveId !== undefined) {
      const { data } = await APICall(DeleteInsertedLeave, "POST", {
        Id: employeeLeaveId,
      });
    } else {
      const tempArr = empData.filter((i) => {
        return i.leaveId === empDataLeaveId;
      });
      setEmpData(tempArr);
    }
    await getEmployeeLeaveData();
    handleClose();
  };

  const options = {
    selectableRows: "none",
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
  };

  const updateAppliedLeaves = async (id, check) => {
    const obj = employeeLeaveTypeOptions.find((i) => i.value === id);
    setEmployeeLeavesData(obj);
    if (check) {
      await getEmployeeLeave(id);
    } else {
      const temp = empData.find((i) => i.leaveId === id);

      setLeaveBalance(temp.balance);
    }
  };

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 360,
    bgcolor: "background.paper",

    boxShadow: 24,
    p: 4,
  };

  // Added custom color for tooltip
  const customColors = ["#2755f3", "#e74c3c"];

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "leaveId",
      label: "Leave Id",
      options: {
        display: false,
      },
    },
    {
      name: "name",
      label: "Name",
    },
    {
      name: "leave",
      label: "Leave Type",
    },
    {
      name: "balance",
      label: "Leave Balance",
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          let leaveId = tableMeta.tableData[tableMeta.rowIndex].leaveId;
          let check = id !== undefined ? true : false;

          return (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    updateAppliedLeaves(leaveId, check);
                  }}
                  className="action_icon"
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </a>
              </Tooltip>
              <Tooltip title="Delete" color={customColors[1]}>
                <a
                  className="action_icon"
                  onClick={() => {
                    handleOpen(id, leaveId);
                  }}
                >
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </a>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];
  return (
    <>
      <Heading title={"Employee Master"} />
      <div className="container-fluid">
        <div className="row">
          {/* Employee Id */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Employee Id <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={employeeEid}
                onChange={(e) => setEmployeeEid(e.target.value)}
              />
            </div>
          </div>
          {/* Employee Name */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Employee Name <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
              />
            </div>
          </div>
          {/* Employee Short Name */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Login ID <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={employeeShortName}
                onChange={(e) => setEmployeeShortName(e.target.value)}
              />
            </div>
          </div>
          {/* Login Id */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Email Id <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={employeeLoginId}
                onChange={(e) => setEmployeeLoginId(e.target.value)}
                type={"email"}
              />
            </div>
          </div>
          {/* Birth Date */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Birth Date <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="BirthDate"
                  value={employeeBirthDate}
                  onChange={(e) => selectOnChange(e, "birthDate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8], // Keeps the calendar positioned 8px below the field
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport", // Keeps the calendar within the viewport
                        },
                      },
                    ],
                  }}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>{formErrors["birthError"]}</p>
            </div>
          </div>
          {/* Joining Date */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Joining Date <sup>*</sup>
              </label>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Joining Date"
                  value={employeejoiningDate}
                  onChange={(e) => selectOnChange(e, "joiningDate")}
                  inputFormat="dd/MM/yyyy"
                  renderInput={(params) => (
                    <TextField size="small" {...params} />
                  )}
                  PopperProps={{
                    disablePortal: true,
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8], // Keeps the calendar positioned 8px below the field
                        },
                      },
                      {
                        name: "preventOverflow",
                        options: {
                          enabled: true,
                          boundariesElement: "viewport", // Keeps the calendar within the viewport
                        },
                      },
                    ],
                  }}
                />
              </LocalizationProvider>
              <p style={{ color: "red" }}>{formErrors["joinError"]}</p>
            </div>
          </div>

          {/* Cost Center */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Vertical <sup>*</sup>
              </label>
              <SelectForm
                options={employeeCostCenterOption}
                placeholder="Select"
                isDisabled={false}
                value={CostCenter}
                onChange={(event) => selectOnChange(event, "CostCenter")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
          </div>

          {/*  Work Policy */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Work Policy <sup>*</sup>
              </label>
              <SelectForm
                options={employeeWorkPolicyOption}
                placeholder="Select"
                isDisabled={false}
                value={WorkPolicy}
                onChange={(event) => selectOnChange(event, "workPolicy")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
          </div>
          {/* Timesheet Policy */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Timesheet Policy <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={employeeTimesheetPolicyOption}
                placeholder="Select"
                isDisabled={false}
                value={TimesheetPolicy}
                onChange={(event) => selectOnChange(event, "TimesheetPolicy")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
          </div>

          {/* Efficiency */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Efficiency <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={employeeEfficiencyOption}
                placeholder="Select"
                isDisabled={false}
                value={Efficiency}
                onChange={(event) => selectOnChange(event, "Efficiency")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
          </div>

          {/* Role */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Role <sup>*</sup>
              </label>
              <SelectForm
                options={employeeRoleOption}
                placeholder="Select"
                isDisabled={false}
                value={employeeRole}
                onChange={(event) => selectOnChange(event, "Roles")}
                isMulti={true}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
          </div>

          {/* Reporting Manager */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Reporting Manager <sup>*</sup>
              </label>
              <SelectForm
                options={reportingManagerOption}
                placeholder="Select"
                isDisabled={false}
                value={reportingManager}
                onChange={(event) => selectOnChange(event, "reportingManager")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
          </div>
          {/* Designation */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Designation <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={employeeDesignation}
                onChange={(e) => {
                  setFormErrors({ ...formErrors, designationError: "" });
                  setEmployeeDesignation(e.target.value);
                }}
              />
              <p style={{ color: "red" }}>{formErrors["designationError"]}</p>
            </div>
          </div>
          {/* Contact Number */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Contact Number <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={contactNumber}
                onChange={(e) => {
                  setFormErrors({ ...formErrors, Number_isNotinFormat: "" });
                  handleContactEvent(e, "Contact");
                }}
              />
              <p style={{ color: "red" }}>
                {formErrors["Number_isNotinFormat"]}
              </p>
            </div>
          </div>

          {/* Emergency Contact Number */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Emergency Contact Number <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={emergencyContact}
                onChange={(e) => {
                  setFormErrors({
                    ...formErrors,
                    emerygency_isNotinFormat: "",
                  });
                  handleEmergencyContactEvent(e, "eContact");
                }}
              />
              <p style={{ color: "red" }}>
                {formErrors["emerygency_isNotinFormat"]}
              </p>
            </div>
          </div>
          {/* Location */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Location <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={location}
                onChange={(e) => {
                  setFormErrors({ ...formErrors, locationError: "" });
                  setLocation(e.target.value);
                }}
              />
              <p style={{ color: "red" }}>{formErrors["locationError"]}</p>
            </div>
          </div>

          {/* Is Active */}
          {state && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label htmlFor="isActive">Is Active</label>
                <div>
                  <input
                    id="isActive"
                    type="checkbox"
                    onChange={(e) => setIsActive(e.target.checked)}
                    name="isActive"
                    checked={isActive}
                  />
                </div>
              </div>
            </div>
          )}
          {state && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Last Working Date <sup>*</sup>
                </label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Last Working Date"
                    value={employeeleavingDate}
                    onChange={(e) => selectOnChange(e, "leavingDate")}
                    inputFormat="dd/MM/yyyy"
                    renderInput={(params) => (
                      <TextField size="small" {...params} />
                    )}
                  />
                </LocalizationProvider>
                <p style={{ color: "red" }}>{formErrors["leaveError"]}</p>
              </div>
            </div>
          )}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Leave Type <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={employeeLeaveTypeOptions}
                placeholder="Select"
                isDisabled={false}
                value={employeeLeaveTypeSelectedData}
                onChange={(event) => selectOnChange(event, "EmployeeLeaveType")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Leave Balance <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={leaveBalance}
                onChange={(e) => setLeaveBalance(e.target.value)}
                className="numRight"
                type="number"
                onKeyPress={(event) => {
                  if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </div>
          <div className="col-lg-12">
            <button
              onClick={() => onClickFunction("add")}
              className="btn btn-update"
            >
              Add Leave Type <sup>*</sup>
            </button>
          </div>

          <div className="col-lg-12 mt-3">
            {gridData.length > 0 && (
              <DynamicGrid
                options={options}
                data={gridData}
                columns={gridColumns}
              />
            )}
          </div>

          <div className="col-lg-12 mt-3">
            <div className="d-flex justify-content-between">
              <div>
                <button onClick={() => navigate(-1)} className="btn btn-reset">
                  <i className="fa fa-chevron-left"></i>
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={() => onClickFunction("reset")}
                  className="btn btn-reset"
                >
                  Reset
                </button>

                <button
                  onClick={() => onClickFunction("submit")}
                  className="btn btn-submit"
                  // disabled={gridData.length === 0}
                  disabled={disabled}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={open}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="sm"
      >
        <Modal.Body className="text-center delete_body p-4">
          <i className="fa fa-info mb-3"></i>
          <p className="mb-3">Are you sure, you want to delete?</p>
          <div className="row justify-content-center gap-2">
            <button
              type="button"
              onClick={() => handleClose()}
              className="btn btn-reset"
            >
              No
            </button>
            <button
              type="button"
              className="btn btn-delete"
              onClick={() => {
                removeAppliedLeave();
              }}
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EmployeeMasterEdit;
